
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
  } from '@chakra-ui/react'
  import ExpertDataService from "../../services/Expert";
export const DeleteProgrammeModal = ({isOpen,onClose, id, expertid,func,clear}:any) => {
  // console.log(id);
  // console.log(expertid);
  const deleteAssessments = () => {
    ExpertDataService.deleteProgramme(expertid,id)
      .then((response: any) => {
        func();
        clear();
       onClose();
      })
      .catch((e: Error) => {
        onClose();
        console.log(e);
      });
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Expert</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          Are you sure you want to delete this attendance?
          </ModalBody>

          <ModalFooter>
          <Button  bgColor='#327171' color={"white"} mr={3} onClick={deleteAssessments} >Delete</Button>
            <Button  bgColor='red' color={"white"} mr={3} onClick={onClose}>
              No
            </Button>
           
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}

